import React, { useState, useContext, useEffect } from 'react';
import _ from 'lodash';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import { useTheme, makeStyles, ThemeProvider } from '@mui/styles';
import {
  // Button,
  IconButton,
  InputLabel,
  Link,
  Typography,
  Alert,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { Context } from '../../context/Context';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import clsx from 'clsx';
import LogoSign from '../../assets/Logologo.png';
import bg1 from '../../assets/bgImages/01.jpg';
import bg2 from '../../assets/bgImages/02.jpg';
// import { signInPanel } from '../../graphql/queries/auth/auth';
// import { useActions } from 'store/actions';
// import { useLazyQuery } from '@apollo/react-hooks';

import SaveAction from '../../components/ContentContainer/SaveAction';
import TextFieldWidgetText2 from '../../components/TextFieldWidget/TextFieldWidgetText2';
// import classes from './SignIn.module.scss';
import { BsContainer, BsRow, BsCol } from '../../layouts/components';
import viewsTexts from '../../common/viewsTexts.json';
import generalTexts from '../../common/generalTexts.json';

import useAuth from '../../customHooks/useAuth';
import { FiltersContext } from '../../context/filters/FiltersContext';
import {
  modulesPlatform,
  arrayIdDashboards,
  arrayIdsDetail,
  arrayIdsResume,
  arrayIdsAnalysis,
  arrayIdPowerBi,
  arrayIdSchedule,
} from '../../helpers/menuModules';
import { getModulesProcessIds } from '../../helpers/functionHelpers';
import UserProfile from '../../common/profiles.json';

const randomBackground = () => {
  const arrayBackgrounds = [bg1, bg2];
  const random = Math.floor(Math.random() * arrayBackgrounds.length);
  return arrayBackgrounds[random];
};

const useStyles = makeStyles((theme) => ({
  loginContainerStyle: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    // backgroundColor: 'yellow',
    padding: '20px 10px',
    justifyContent: 'space-between',
  },
  logoStyle: {
    width: 152,
  },
  formContainerStyle: {
    width: '50%',
    margin: '0 auto',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  footerContainerStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderTop: '1px solid' + theme.palette.grey[500],
    paddingTop: theme.spacing(3),
  },
  buttonContainerStyle: {
    marginTop: theme.spacing(4),
  },
  bgImagesStyle: {
    backgroundImage: `url(${randomBackground()})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '100%',
  },
}));

const SignIn = (props) => {
  const context = useContext(Context);

  // const { getMyOrchardsInfo } = useContext(FiltersContext);

  // const [loadingState, setLoadingState] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const [errorProfileState, setErrorProfileState] = useState(false);

  const { login, user, accessToken, error, busy } = useAuth();

  const theme = useTheme();

  console.log(theme, '<-------', UserProfile);
  const classes = useStyles();

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const handleClickShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const onSubmit = async (values) => {
    setErrorProfileState(false);
    const { user, password } = values;

    // hacer trim del user
    const userTrim = user.trim();
    const passwordTrim = password.trim();

    try {
      await login(userTrim, passwordTrim, 'user:me');
    } catch (e) {
      // console.log(e, 'error login');
      // alert('Hubo un error' + e);
    }
  };

  useEffect(() => {
    console.log(user, 'llega la data RESPUESTA LOGIN');
    // ejecutar evento login

    if (user && accessToken) {
      let roleId = user.roleId.id;

      const profileId = user?.profile?.id;

      if (
        // admin panel y contador no entran
        profileId !== UserProfile.UserProfile[3].id &&
        profileId !== UserProfile.UserProfile[4].id
      ) {
        const tagManagerArgs = {
          gtmId: 'GTM-W87D5MS',
          dataLayer: {
            userId: user._id,
            clientName: user.client?.label,
            fullName: `${user.name} ${user.lastname}`,
            userName: user.username,
            profileName: user.profile?.label,
          },
        };
        TagManager.initialize(tagManagerArgs);

        const ACTUAL_MODULES = [
          '000000000000000000000000',
          '6422e4d13f15d6fddadfcb8a',
          '6478c8a3b722d8c83ac83b65',
          '651eab668dd2652ad27fc094',
          '6423302fa603384a5039a60f',
          '642333cb241198d7ea424c03',
          '64234ac2f7b53d43704e067b',
          '6422f05b89487f570c713901',
          '64234ed70ba2eaeaeafc3496',
          '64f87e1ada19593a715a6292',
          '64e62ced5c228dec08aaf0e9',
          '64ef4f50e252668d3c000048',
          '668407849f5946eca6727733',
          '669faf6703ff26455e350435',
          '66d0ca968244d5872f356a03',
          '67475b98ae573778c932b250',
          '679a3e5ad93a53b7b8f65f31',
          '681d191d1c57e97f1fca169c',
          '66f0ab668dd2652ad27fc120', // Visit module
          '6a3d96c27af93206f30a556d', // Quality Control module
        ];

        // const PRODUCTION_MODULES = [
        //   '000000000000000000000000', // menu
        //   '6422e4d13f15d6fddadfcb8a', // biblioteca
        //   '6478c8a3b722d8c83ac83b65', // análisis
        //   '651eab668dd2652ad27fc094', // pla. cosecha
        //   //'6423302fa603384a5039a60f', // huerto
        //   // '642333cb241198d7ea424c03', // poda
        //   '64234ac2f7b53d43704e067b', // conteo
        //   '6422f05b89487f570c713901', // clima
        //   '64234ed70ba2eaeaeafc3496', // muestreo
        //   '64f87e1ada19593a715a6292', // usabilidad,
        //   // '64e62ced5c228dec08aaf0e9', // dashboard estimativo
        //   // '64ef4f50e252668d3c000048', // dashboard rendimiento
        //   // '668407849f5946eca6727733', // powerbi
        // ];

        let ACTIVE_MODULES = ACTUAL_MODULES;

        // Hardcode (testing): solo garcesfruit ve Laboratory Documents
        if (user.username === 'garcesfruit') {
          ACTIVE_MODULES = [
            ...ACTIVE_MODULES,
            '6422e4d13f15d6fddadfcb8b', // Laboratory Documents Module
          ];
        }

        // dejar solo los modulos que tiene ACTUAL_MODULES
        const modulesFiltered = modulesPlatform.filter((module) =>
          ACTIVE_MODULES.includes(module.id)
        );

        const arrayAsignedIds = getModulesProcessIds(user.moduleProcess);

        // FOR TESTING: quitar cuando se añadan por backend
        //arrayAsignedIds.push(
          //'66f0ab668dd2652ad27fc120', // Visit module
          //'66f0acc98dd2652ad27fc121', // Quality Visit process
          //'66f0ace08dd2652ad27fc123', // Technical Visit process
        //);

        //Solo para cliente Garces_Fruit
        if (user.username === 'garcesfruit') {
          arrayAsignedIds.push('680b1f4f2854b05c99bcc3c3'); // Formulario Estimación Diario

          // Laboratory Documents
          arrayAsignedIds.push(
            '6422e4d13f15d6fddadfcb8b', // módulo
            '6422e8ed3b513fe22b595a8d', // proceso: Documentos de Laboratorio
          );
        }

        let menuAsigned;

        if (arrayAsignedIds.length) {
          // 2-recorro menu plataforma
          // revisando si el id está en los asignados
          menuAsigned = modulesFiltered.map((module) => {
            if (!module.subMenu) {
              const moduleExist = arrayAsignedIds.includes(module.id);

              const resultModuleBackend = user.moduleProcess.filter(
                (ele) => ele.id === module.id
              );

              const { process = [], ...others } =
                resultModuleBackend?.[0] || {};

              // console.log('sin subs', module, others);

              return {
                ...module,
                ...others,
                name: module.name,
                namePrint: module.namePrint,
                processBackend: process,
                // asignado si tiene el id en Exist y si es Home Menu
                assigned:
                  module.id === '000000000000000000000000' ? true : moduleExist,
              };
            } else {
              // CON SUBMENU
              let moduleExist = false;
              // tiene submenu
              let processesModulesDash;

              moduleExist = arrayAsignedIds.includes(module.id);

              const resultModuleBackend = user.moduleProcess.filter(
                (ele) => ele.id === module.id
              );

              const { process = [], ...others } =
                resultModuleBackend?.[0] || {};

              const processAssigned = module.process.map((process) => {
                let processExist = false;

                processExist = arrayAsignedIds.includes(process.id);

                return {
                  ...process,
                  assigned: processExist,
                };
              });

              // Procesos-permiso (no son tabs): mismo criterio de asignación que `process`.
              const featureProcessAssigned = (module.featureProcess || []).map(
                (process) => ({
                  ...process,
                  assigned: arrayAsignedIds.includes(process.id),
                })
              );

              // sin tiene procesos activos le inhabilita el módulo
              const hasAssignedProcess = processAssigned.filter(
                (process) => process.assigned === true
              );

              return {
                ...module,
                ...others,
                name: module.name,
                namePrint: module.namePrint,
                href: hasAssignedProcess[0]?.href || module.href,
                processBackend: process.length ? process : processesModulesDash,
                process: processAssigned,
                featureProcess: featureProcessAssigned,
                assigned: hasAssignedProcess.length ? moduleExist : false,
              };
            }
          });
        } else {
          // menuAsigned = modulesFiltered;
          menuAsigned = [];
        }

        let menuUser = menuAsigned;

        const initialMenuItem = menuUser.filter((ele) => ele.assigned)[0];

        // const initialRoute =
        //   initialMenuItem?.process[0]?.href || initialMenuItem?.href || 'home';

        const initialRoute = 'home';

        context.login(
          accessToken,
          user._id,
          user.name,
          user.lastname,
          user.username,
          user.profile, // ejemplo
          user.profile?.id,
          user.orchard,
          menuUser,
          user?.client,
          initialRoute
        );
      } else {
        setErrorProfileState(true);
      }
    }
  }, [user, accessToken, error]);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'logOut',
      userId: '',
      clientName: '',
      fullName: '',
      userName: '',
      profileName: '',
    });
  }, []);

  return (
    <BsContainer fluid class='h-100' style={{ height: '100%' }}>
      <BsRow class='h-100'>
        <BsCol class='col-12 col-md-8 col-lg-7'>
          <div className={classes.loginContainerStyle}>
            <div>
              <img
                src={LogoSign}
                alt='analytics'
                className={clsx('mb-4 mt-3 img-fluid', classes.logoStyle)}
              />
            </div>
            <div className={classes.formContainerStyle}>
              <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                <Typography variant='h2' gutterBottom sx={{ fontWeight: 700 }}>
                  {viewsTexts.titles.signin.title}
                </Typography>
                <Typography variant='h5'>
                  {viewsTexts.titles.signin.sugestion}
                </Typography>
                <div className='mt-5 mt-md-4'>
                  <TextFieldWidgetText2
                    name='user'
                    display='vertical'
                    labeltext=''
                    placeholder='Nombre usuario o Email'
                    req
                    defaultValue=''
                    className='mb-2'
                    disabled={busy}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    // InputProps={{
                    //   endAdornment: (
                    //     <InputAdornment position='end'>Kg</InputAdornment>
                    //   ),
                    // }}
                    InputProps={{
                      sx: {
                        borderRadius: 40,
                      },
                    }}
                    control={control}
                    errors={errors.user}
                    // sx={{ borderRadius: 40 }}
                  />
                  <TextFieldWidgetText2
                    name='password'
                    display='vertical'
                    type={showPassword ? 'text' : 'password'}
                    labeltext=''
                    placeholder='Contraseña'
                    req
                    defaultValue=''
                    disabled={busy}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      sx: {
                        borderRadius: 40,
                      },
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton
                            aria-label='toggle password visibility'
                            color='default'
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    control={control}
                    errors={errors.password}
                  />
                  <div className='text-right mt-2'>
                    <Typography>
                      <Link
                        color='primary'
                        component={RouterLink}
                        to='/recovery-password'
                        variant='body2'
                      >
                        {generalTexts.textRecoveryPassword}
                      </Link>
                    </Typography>
                  </div>
                  <div className={classes.buttonContainerStyle}>
                    <SaveAction
                      title='Ingresar'
                      color='secondary'
                      size='large'
                      className='bigButton'
                      fullWidth={true}
                      variant='contained'
                      messageType='add'
                      mutationLoading={busy}
                      success={false}
                      sx={{
                        borderRadius: 40,
                      }}
                    />
                  </div>
                </div>
                {error && (
                  <div className='text-center mt-3'>
                    <Alert severity='error' variant='filled'>
                      Usuario o contraseña incorrectos.
                    </Alert>
                  </div>
                )}
                {errorProfileState && (
                  <div className='text-center'>
                    <Alert severity='error' variant='filled'>
                      Perfil de usuario incorrecto.
                    </Alert>
                  </div>
                )}
              </form>
            </div>
            <div className={classes.footerContainerStyle}>
              <Typography variant='body1'>¿No tienes cuenta?</Typography>
              <Typography>
                <Link
                  color='primary'
                  variant='body2'
                  sx={{ ml: 2, textDecoration: 'none' }}
                  href='mailto:contacto@ceranalytics.com'
                >
                  contacto@ceranalytics.com
                </Link>
                <Link
                  color='primary'
                  variant='body2'
                  sx={{ ml: 2, textDecoration: 'none' }}
                  href='tel:+56442226645'
                >
                  +56 442226645
                </Link>
              </Typography>
            </div>
          </div>
        </BsCol>
        <BsCol class='col pr-0 d-none d-md-block'>
          <div className={classes.bgImagesStyle}></div>
        </BsCol>
      </BsRow>
    </BsContainer>
  );
};

export default withRouter(SignIn);
